import {
  Switch as HUISwitch,
  SwitchProps as HUISwitchProps,
} from '@headlessui/react';
import { FC, Fragment } from 'react';
import { cx } from '@/utils/cx';

export type SwitchProps = Omit<HUISwitchProps, 'checked'> & {
  enabled: boolean;
  label: string;
};

// TODO: move into components/form?
export const Switch: FC<SwitchProps> = ({
  className,
  enabled,
  label,
  ...props
}) => (
  <HUISwitch checked={enabled} {...props} as={Fragment}>
    {({ checked, disabled }) => (
      <button
        className={cx(
          'focusable',
          'inline-flex h-6 w-10 flex-shrink-0 items-center rounded-full p-0.5',
          checked ? 'bg-successShade' : 'bg-warningShade',
          disabled && 'cursor-not-allowed opacity-50',
          className,
        )}
      >
        <span className="sr-only">{label}</span>
        <span
          className={cx(
            'size-5 rounded-full bg-white transition',
            checked && 'translate-x-4',
          )}
        />
      </button>
    )}
  </HUISwitch>
);
